import { DRIFT_TONE } from '@/features/profiler';
import type { DriftVerdict } from '@/features/profiler';

import type { Freshness } from '../model/estate';

/** The colour a freshness band is drawn in. Total maps, so a fifth band is a compile error. */
export const FRESHNESS_TONE = {
  stale: 'risk',
  ageing: 'watch',
  fresh: 'good',
  never: 'none',
} as const satisfies Record<Freshness, string>;

/** The profiler's tones in this screen's vocabulary. */
const FROM_DRIFT_TONE = {
  ok: 'good',
  info: 'info',
  warn: 'watch',
  error: 'risk',
  unknown: 'none',
} as const;

/** The colour a drift verdict is drawn in, read from the profiler's map so this screen and the dataset
 * page always agree: a value set that turned over is amber, a distribution that moved is blue, and
 * "cannot say" is the hollow grey that means nothing was compared rather than nothing changed. */
export const VERDICT_TONE = {
  stable: FROM_DRIFT_TONE[DRIFT_TONE.stable],
  moved: FROM_DRIFT_TONE[DRIFT_TONE.moved],
  replaced: FROM_DRIFT_TONE[DRIFT_TONE.replaced],
  unmeasurable: FROM_DRIFT_TONE[DRIFT_TONE.unmeasurable],
} as const satisfies Record<DriftVerdict, string>;

/** The chart fills an inline gradient is built from, as whole token names rather than assembled
 * ones, so a renamed token is a search away rather than hidden inside a template string. */
export const FILL_VAR = {
  good: 'var(--pf-fill-good)',
  watch: 'var(--pf-fill-watch)',
  risk: 'var(--pf-fill-risk)',
  info: 'var(--pf-fill-info)',
  none: 'var(--pf-fill-none)',
  teal: 'var(--pf-fill-teal)',
} as const;

/** The freshness donut's segment colours. */
export const DONUT_VAR = {
  stale: 'var(--pf-donut-stale)',
  ageing: 'var(--pf-donut-ageing)',
  fresh: 'var(--pf-donut-fresh)',
  never: 'var(--pf-donut-never)',
} as const satisfies Record<Freshness, string>;
